import { KnmPmFormFieldsNamesTemplatesEnum } from '../enums/KnmPmFormFieldsNamesTemplatesEnum';

export const knmPmErrorFieldsArrangeArray: Array<KnmPmFormFieldsNamesTemplatesEnum> = [
  KnmPmFormFieldsNamesTemplatesEnum.MANUAL_ADDRESS,
  KnmPmFormFieldsNamesTemplatesEnum.REGION,
  KnmPmFormFieldsNamesTemplatesEnum.KNO_ORGANIZATION,
  KnmPmFormFieldsNamesTemplatesEnum.SUPERVISION_TYPE,
  KnmPmFormFieldsNamesTemplatesEnum.PM_TYPE,
  KnmPmFormFieldsNamesTemplatesEnum.START_DATE,
  KnmPmFormFieldsNamesTemplatesEnum.STOP_DATE,
  KnmPmFormFieldsNamesTemplatesEnum.REASONS,
  KnmPmFormFieldsNamesTemplatesEnum.REASON,
  KnmPmFormFieldsNamesTemplatesEnum.REASON_TYPE,
  KnmPmFormFieldsNamesTemplatesEnum.REASON_TEXT,
  KnmPmFormFieldsNamesTemplatesEnum.REASON_DATE,
  KnmPmFormFieldsNamesTemplatesEnum.REASON_DATE_REQUIREMENT,
  KnmPmFormFieldsNamesTemplatesEnum.REASON_RISK_INDICATORS_VALUE,
  KnmPmFormFieldsNamesTemplatesEnum.REASON_RISK_INDICATOR_VALUE,
  KnmPmFormFieldsNamesTemplatesEnum.REASON_RISK_INDICATOR,
  KnmPmFormFieldsNamesTemplatesEnum.REASON_RISK_INDICATOR_AUTO,
  KnmPmFormFieldsNamesTemplatesEnum.REASON_RISK_INDICATOR_FILE,
  KnmPmFormFieldsNamesTemplatesEnum.REASON_PLAN_KNM,
  KnmPmFormFieldsNamesTemplatesEnum.IS_SONKO_REGISTRY,
  KnmPmFormFieldsNamesTemplatesEnum.IS_MSP_REGISTRY,
  KnmPmFormFieldsNamesTemplatesEnum.IS_NKO_REGISTRY,
  KnmPmFormFieldsNamesTemplatesEnum.OKVEDS,
  KnmPmFormFieldsNamesTemplatesEnum.OKVED,
  KnmPmFormFieldsNamesTemplatesEnum.OKVED_OKVED,
  KnmPmFormFieldsNamesTemplatesEnum.OBJECTS,
  KnmPmFormFieldsNamesTemplatesEnum.OBJECT,
  KnmPmFormFieldsNamesTemplatesEnum.OBJECT_OBJECT_NAME,
  KnmPmFormFieldsNamesTemplatesEnum.OBJECT_ADDRESS,
  KnmPmFormFieldsNamesTemplatesEnum.OBJECT_OBJECT_TYPE,
  KnmPmFormFieldsNamesTemplatesEnum.OBJECT_OBJECT_KIND,
  KnmPmFormFieldsNamesTemplatesEnum.OBJECT_OBJECT_SUB_KIND,
  KnmPmFormFieldsNamesTemplatesEnum.OBJECT_RISK_CATEGORY,
  KnmPmFormFieldsNamesTemplatesEnum.OBJECT_REGION,
  KnmPmFormFieldsNamesTemplatesEnum.OBJECT_MANUAL_ADDRESS,
  KnmPmFormFieldsNamesTemplatesEnum.INSPECTORS,
  KnmPmFormFieldsNamesTemplatesEnum.INSPECTOR,
  KnmPmFormFieldsNamesTemplatesEnum.INSPECTOR_FULL_NAME,
  KnmPmFormFieldsNamesTemplatesEnum.INSPECTOR_POSITION,
  KnmPmFormFieldsNamesTemplatesEnum.EXPERTS,
  KnmPmFormFieldsNamesTemplatesEnum.EXPERT,
  KnmPmFormFieldsNamesTemplatesEnum.EXPERT_TITLE,
  KnmPmFormFieldsNamesTemplatesEnum.EXPERT_TYPE,
  KnmPmFormFieldsNamesTemplatesEnum.COLLABORATING_ORGANIZATIONS,
  KnmPmFormFieldsNamesTemplatesEnum.COLLABORATING_ORGANIZATIONS_ITEM,
  KnmPmFormFieldsNamesTemplatesEnum.COLLABORATING_ORGANIZATIONS_ITEM_ORGANIZATION,
  KnmPmFormFieldsNamesTemplatesEnum.COLLABORATING_ORGANIZATIONS_ITEM_TITLE,
  KnmPmFormFieldsNamesTemplatesEnum.REQUIREMENTS_NPA,
  KnmPmFormFieldsNamesTemplatesEnum.REQUIREMENTS_NPA_I,
  KnmPmFormFieldsNamesTemplatesEnum.REQUIREMENTS_NPA_ITEM,
  KnmPmFormFieldsNamesTemplatesEnum.REQUIREMENTS_NPA_MANDATORY,
  KnmPmFormFieldsNamesTemplatesEnum.REQUIREMENTS_NPA_MANDATORY_ITEM,
  KnmPmFormFieldsNamesTemplatesEnum.PM_RESULT_DECISIONS,
  KnmPmFormFieldsNamesTemplatesEnum.PM_RESULT_DECISION,
  KnmPmFormFieldsNamesTemplatesEnum.ACT,
  KnmPmFormFieldsNamesTemplatesEnum.ACT_TYPE_ACT,
  KnmPmFormFieldsNamesTemplatesEnum.ACT_CANCELED_REASON_DESCRIPTION,
  KnmPmFormFieldsNamesTemplatesEnum.ACT_CANCELED_REASON_DESCRIPTION_REACT_QUILL_EDITOR,
  KnmPmFormFieldsNamesTemplatesEnum.ACT_CANCELED_REASON,
  KnmPmFormFieldsNamesTemplatesEnum.ACT_DOCUMENTS_ATTACHMENTS,
  KnmPmFormFieldsNamesTemplatesEnum.ACT_CREATION_ACT_DATE_TIME,
  KnmPmFormFieldsNamesTemplatesEnum.ACT_HOLDING_DATE_TIME,
  KnmPmFormFieldsNamesTemplatesEnum.ACT_KNO_INSPECTORS,
  KnmPmFormFieldsNamesTemplatesEnum.ACT_KNO_INSPECTOR,
  KnmPmFormFieldsNamesTemplatesEnum.ACT_KNO_INSPECTOR_KNO_INSPECTOR,
  KnmPmFormFieldsNamesTemplatesEnum.ACT_KNO_INSPECTOR_FULL_NAME,
  KnmPmFormFieldsNamesTemplatesEnum.ACT_KNO_INSPECTOR_POSITION,
  KnmPmFormFieldsNamesTemplatesEnum.ACT_FIO_READER,
  KnmPmFormFieldsNamesTemplatesEnum.ACT_REFUSER_FIO,
  KnmPmFormFieldsNamesTemplatesEnum.ACT_REFUSER_TITLE,
  KnmPmFormFieldsNamesTemplatesEnum.ACT_ACQUAINTANCE_TYPE,
  KnmPmFormFieldsNamesTemplatesEnum.ACT_ACQUAINTANCE_LACK_TYPE,
  KnmPmFormFieldsNamesTemplatesEnum.ACT_TITLE_READER,
  KnmPmFormFieldsNamesTemplatesEnum.ACT_DURATION_DAYS,
  KnmPmFormFieldsNamesTemplatesEnum.ACT_DURATION_HOURS,
  KnmPmFormFieldsNamesTemplatesEnum.ACT_EVENTS,
  KnmPmFormFieldsNamesTemplatesEnum.ACT_EVENT,
  KnmPmFormFieldsNamesTemplatesEnum.ACT_EVENT_INSPECTORS,
  KnmPmFormFieldsNamesTemplatesEnum.ACT_EVENT_INSPECTOR_FULL_NAME,
  KnmPmFormFieldsNamesTemplatesEnum.ACT_EVENT_START_DATE,
  KnmPmFormFieldsNamesTemplatesEnum.ACT_EVENT_STOP_DATE,
  KnmPmFormFieldsNamesTemplatesEnum.ACT_EVENT_LINK_VKS,
  KnmPmFormFieldsNamesTemplatesEnum.ACT_EVENT_LINK_VIDEO,
  KnmPmFormFieldsNamesTemplatesEnum.ACT_EVENT_TYPE,
  KnmPmFormFieldsNamesTemplatesEnum.ACT_EVENT_UAV_TECHNOLOGIES,
  KnmPmFormFieldsNamesTemplatesEnum.ACT_EVENT_UAV_TECHNOLOGIES_TYPE,
  KnmPmFormFieldsNamesTemplatesEnum.ACT_EVENT_UAV_TECHNOLOGIES_NAME,
  KnmPmFormFieldsNamesTemplatesEnum.ACT_IS_VIOLATED_REQUIREMENTS_MANDATORY,
  KnmPmFormFieldsNamesTemplatesEnum.ACT_VIOLATED_REQUIREMENTS,
  KnmPmFormFieldsNamesTemplatesEnum.ACT_VIOLATED_REQUIREMENTS_MANDATORY,
  KnmPmFormFieldsNamesTemplatesEnum.ACT_VIOLATED_REQUIREMENTS_MANDATORY_ITEM,
  KnmPmFormFieldsNamesTemplatesEnum.ACT_VIOLATED_REQUIREMENTS_MANDATORY_ITEM_CATEGORY,
  KnmPmFormFieldsNamesTemplatesEnum.ACT_VIOLATED_REQUIREMENTS_MANDATORY_ITEM_VIOLATIONS,
  KnmPmFormFieldsNamesTemplatesEnum.ACT_VIOLATED_REQUIREMENTS_MANDATORY_ITEM_VIOLATION_TITLE,
  KnmPmFormFieldsNamesTemplatesEnum.ACT_VIOLATED_REQUIREMENTS_MANDATORY_ITEM_VIOLATION_FIXED_ON_PLACE,
  KnmPmFormFieldsNamesTemplatesEnum.ACT_VIOLATED_REQUIREMENTS_MANDATORY_ITEM_VIOLATION_FIXED,
  KnmPmFormFieldsNamesTemplatesEnum.ACT_FIO_AND_POSITION_SIGNER,
  KnmPmFormFieldsNamesTemplatesEnum.ACT_FIO_SIGNER,
  KnmPmFormFieldsNamesTemplatesEnum.ACT_TITLE_SIGNER,
  KnmPmFormFieldsNamesTemplatesEnum.ACT_NUMBER_ACT,
];
